<!-- eslint-disable max-len -->
<template>
  <div id="management-plan-details">
    <div class='card' >
      <div class='card-body'>
        <div>
          <span class='section-title'>Step 1: </span>
          <span>Select Plan Type</span>
        </div>
        <b-form-select v-model='managementPlan.planType' :options='planTypeOptions' class="m-2" size="sm"/>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ManagementPlanDetails',
  computed: {
    ...mapState(['config']),
    ...mapState('ManagementPlan', { managementPlan: (state) => state.managementPlan }),
  },
  data() {
    return {
      planTypeOptions: [],
      dismissGeocodeWarning: 0,
    };
  },
  mounted() {
    this.planTypeOptions = this.config.managementPlanForm.planTypeOptions;
    this.managementPlan.planType = this.planTypeOptions[0].value;
  },
  methods: {
  },
};
</script>
